import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import TrashIcon from '../../../../themes/svg/trashIcon';
import CloseIcon from '../../../../themes/svg/closeIcon';

class DeleteRoom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  componentWillMount() {
    Modal.setAppElement('#estimateBuilderRoot');
  }

  onCloseClick = (e) => {
    this.closeModal();
    e.preventDefault();
  };

  openModal = (e) => {
    this.setState({ modalIsOpen: true });
    e.preventDefault();
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  deleteThisRoom = () => {
    const { deleteRoom, designId, containerId } = this.props;
    deleteRoom(designId, containerId);
    this.closeModal();
  };

  render() {
    return (
      <div className="actionBarItem">
        <div className="actionBarIcon">
          <a href="/" onClick={this.openModal}>
            <TrashIcon />
          </a>
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="estimatebuilder-modal"
          overlayClassName="estimatebuilder-modal-overlay"
          style={{
            content: {
              width: 450,
            },
          }}
        >
          <div className="confirmDeleteModal">
            <h2>Delete Room</h2>

            <div className="modal-close" onClick={this.onCloseClick} tabIndex="-1" role="button">
              <CloseIcon />
            </div>
            <div className="modal-body">
              <p>
                Are you sure you want to delete this room and all of its associated information?
              </p>
              <button className="btn btn-primary" onClick={this.deleteThisRoom}>
                Delete Room
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

DeleteRoom.propTypes = {
  designId: PropTypes.string.isRequired,
  containerId: PropTypes.string.isRequired,
  deleteRoom: PropTypes.func.isRequired,
};

export default DeleteRoom;
